// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"1524":"0c9785161f8fae1873e9","2320":"0c9785161f8fae1873e9","3094":"dd1f68f318c537f37c37","3204":"0c35aca26179e194739a","4008":"bd315407ce922ec23163","5320":"0c9785161f8fae1873e9"}[chunkId] + ".css";
};